import { createFileRoute } from '@tanstack/react-router';
import { ReplenishmentPage } from '@/features/inventory/ReplenishmentPage';
export const Route = createFileRoute('/_dashboard/dashboard/inventory/replenishment/')({
  component: ReplenishmentPage,
});
